import { Experiment as MarvelExperiment, Variant } from '@marvelapp/react-ab-test';
import marvelEmitter from '@marvelapp/react-ab-test/lib/emitter';
import { useEffect } from 'react';
import { sample } from 'lodash';
import { useResponsive } from '/imports/core/api/responsiveContext';
import { getCountry } from 'imports/checkout/api/utils';
import { getCompanyNameByHost, NEW_CHANGES_COMPANY } from '/lib/helpers';

const EXP_NAME = 'exp_generator_phone_tooltip';
const ACTIVE_VARIANTS = ['control', 'with_phone_tooltip'];

export const isGeneratorPhoneTooltip = (host, isAccount = false) => {
  const country = getCountry();
  const companyName = getCompanyNameByHost(host);

  return (
    (NEW_CHANGES_COMPANY.includes(companyName) || marvelEmitter.getActiveVariant(EXP_NAME) === 'with_phone_tooltip') &&
    country === 'FR'
  );
};

const GeneratorPhoneTooltipExp = (props) => {
  const { host } = useResponsive();
  const country = getCountry();
  const companyName = getCompanyNameByHost(host);
  if (country !== 'FR' || NEW_CHANGES_COMPANY.includes(companyName)) return props.children;

  useEffect(() => {
    const localVariant = marvelEmitter.getActiveVariant(EXP_NAME);
    if (!ACTIVE_VARIANTS.includes(localVariant)) {
      marvelEmitter.setActiveVariant(EXP_NAME, sample(ACTIVE_VARIANTS));
    }
  }, []);
  marvelEmitter.defineVariants(EXP_NAME, ACTIVE_VARIANTS);
  return (
    <MarvelExperiment name={EXP_NAME}>
      {ACTIVE_VARIANTS.map((variant) => (
        <Variant key={variant} name={variant}>
          {props.children}
        </Variant>
      ))}
    </MarvelExperiment>
  );
};

export default GeneratorPhoneTooltipExp;
